import { tigerBackRest } from '../tigerBack/tigerBack.rest'
import { ApiError } from '../tigerx/tegerx.api'
import { ETigerXAccount } from '../tigerx/tigerx.config'

export const BybitApi = {}
